import { render, staticRenderFns } from "./network-status-helper-components-10-digital-currency-alternative-resource-item.vue?vue&type=template&id=a2fc022c&"
import script from "./network-status-helper-components-10-digital-currency-alternative-resource-item.vue?vue&type=script&lang=ts&"
export * from "./network-status-helper-components-10-digital-currency-alternative-resource-item.vue?vue&type=script&lang=ts&"
import style0 from "./network-status-helper-components-10-digital-currency-alternative-resource-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels,VIcon})
